<template>
  <main id="selecionar-empresa" class="ohx login-modal">
    <v-content class="ohx">
      <v-container fluid grid-list-xl class="white-background ohx pb-4">
        <v-layout row wrap>
          <v-flex xs12>
            <slot></slot>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<style lang='scss' scoped>
#selecionar-empresa {
  width: 100%;
}
</style>
<script lang="js">
export default {
  name: "BaseModal",
  created() {
    let t = this;
    window.scrollTo(0, 0);
  },
};
</script>





// WEBPACK FOOTER //
// src/components/BaseModal.vue